// Convertible-dilution adjusted FMV preview — emergent feature (S3). Engine layer (framework-free).
import { asConvertedShares } from './convertibles';
/**
 * Preview the per-share common FMV if all convertibles were as-converted into
 * the fully-diluted denominator. Read-only: never mutates `result` or alters
 * the canonical FMV stored on the headline.
 *
 * Returns `null` when the cap table has no convertibles.
 */
export function convertibleAdjustedFmv(result) {
    const cap = result.inputs.capTableSnapshot;
    if (cap.convertibles.length === 0)
        return null;
    const headline = result.headline;
    const convertibleShares = asConvertedShares(cap, headline.totalEquityValue);
    const adjustedFdShares = headline.fullyDilutedShares + convertibleShares;
    const adjustedFmvPerShare = adjustedFdShares > 0 ? headline.commonValuePostDlom / adjustedFdShares : 0;
    const deltaPct = headline.commonFmvPerShare > 0
        ? (adjustedFmvPerShare - headline.commonFmvPerShare) / headline.commonFmvPerShare
        : 0;
    return { convertibleShares, adjustedFdShares, adjustedFmvPerShare, deltaPct };
}
//# sourceMappingURL=convertibleImpact.js.map